<template>
   <section :class="heightContent"  class="home-page relative">
     <slot></slot>
   </section>
</template>
<script>
export default {
  name: 'FigureAnimate',
  props: {
    heightContent: {
      type: String,
      required: true,
    },
  },
};
</script>
<style scoped>
.home-page {
    overflow: hidden;
  }
  .home-page:before, .home-page:after {
    content: "";
    width: 80%;
    height: 60%;
    position: absolute;
    background: rgba(255,255,255,0.07);
    left: -20vmin;
    top: -20vmin;
    animation: morph 15s linear infinite alternate, spin 20s linear infinite;
    will-change: border-radius, transform;
    transform-origin: 55% 55%;
    pointer-events: none;
    z-index:0;
    overflow: hidden;
  }
  .home-page:after {
    width: 40%;
    height: 50%;
    left: auto;
    right: 0vmin;
    top: auto;
    bottom: 0vmin;
    animation: morph 10s linear infinite alternate, spin 26s linear infinite reverse;
    transform-origin: 20% 20%;
    border-radius: 0% 100% 0% 100% / 0% 100% 0% 100% ;
    z-index:0;
  }

  .home-page:before {
    border-radius: 49% 51% 39% 61% / 43% 65% 35% 57%  ;
  }

  @keyframes morph {
    50% {
      border-radius: 49% 51% 39% 61% / 43% 46% 54% 57%  ;
    }

    100% {
      border-radius: 49% 51% 39% 61% / 43% 65% 35% 57%  ;
    }

  }
</style>
